import Page from 'components/layout/Page';
import { GoalsItem, SalesItem } from './BattleReportComponent.types';
import BattleReportGoals from './sections/goals/BattleReportGoals';
import BattleReportHero from './sections/hero/BattleReportHero';
import BattleReportQuarter from './sections/quarter/BattleReportQuarter';

type ContentProps = {
  sales: SalesItem[];
  goals: GoalsItem[];
};

const BattleReportComponent: React.FC<ContentProps> = ({ sales, goals }) => {
  return (
    <Page hasScrollTop>
      <BattleReportHero />
      <BattleReportGoals sales={sales} />
      <BattleReportQuarter sales={sales} goals={goals} />
    </Page>
  );
};

export default BattleReportComponent;
